import Vue from '../main';

export default {
  getByNroDocumento(nroDocumento, {before}) {
    const params = {};
    params['filter'] = [`nroIdentidad:${nroDocumento}`];
    return Vue.$http.get(`${process.env.VUE_APP_ROOT_API}Personas`, {params, before});
  }
}
